import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@tCooneyBrothers/Services/EmailService";

type SubmitContactFormParameter = {
    emailRecipients: string;
    type?: string;
} & HasOnSuccess;

interface CustomSubmitContactUsFormApiParameter extends SubmitContactUsFormApiParameter {
    referenceNumber?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, CustomSubmitContactUsFormApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        firstName: state.fieldValues["firstName"],
        emailAddress: state.fieldValues["emailAddress"],
        comments: state.fieldValues["message"],
        emailTo: props.parameter.emailRecipients,
        company: state.fieldValues["companyName"],
        phoneNumber: state.fieldValues["phoneNumber"],
        referenceNumber: state.fieldValues["referenceNumber"],
        type: props.parameter?.type,
        URL: document.URL,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await submitContactUsForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
